import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap 5
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css"; // DataTable Bootstrap 5 Styles
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; // DataTable Bootstrap 5 Responsive
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import * as XLSX from "xlsx"; // For exporting to Excel
import Header from "../Header";
import "./index.css";

const TransactionList = () => {
  const tableRef = useRef(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  // Fetch Transactions
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://apiaksharaconnect.aksharafinalytics.in/viewtransactions"
        );
        if (!response.ok) throw new Error("Network response was not ok");

        const result = await response.json();
       console.log(result);
        setTransactions(result || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Initialize DataTable
  useEffect(() => {
    if (tableRef.current && transactions.length > 0) {
      const table = $(tableRef.current).DataTable({
        responsive: true,
        autoWidth: false,
        destroy: true, 
        paging: true, 
        pageLength: 10, 
        lengthMenu: [10, 25, 50, 100], 
        columnDefs: [
          { targets: 0, responsivePriority: 1 }, 
          { targets: 1, responsivePriority: 2 },
          { targets: 2, responsivePriority: 3 },
          { targets: 3, responsivePriority: 4 },
          { targets: 4, responsivePriority: 5 },
          { targets: 5, responsivePriority: 6 },
          { targets: 6, responsivePriority: 7 },
        ],
      });

      return () => {
        table.destroy(); // Cleanup on unmount
      };
    }
  }, [transactions]);

  // Export to Excel
  const exportToExcel = () => {
    if (transactions.length === 0) {
      alert("No data to export!");
      return;
    }
    const ws = XLSX.utils.json_to_sheet(transactions);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "transactions");
    XLSX.writeFile(wb, "Transactions_List.xlsx");
  };

  if (loading) return <div className="text-center mt-4">Loading...</div>;

  return (
    <>
      <Header />
      <div className="container-fluid mt-4">
        <div className="card shadow">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4>Transaction Management &nbsp;<button className="btn btn-primary" onClick={() => navigate('/AddPayment')}>
              Add Payment
            </button></h4>
            <button className="btn btn-success" onClick={exportToExcel}>
              Export to Excel
            </button>
          </div>
          <div className="card-body">
            {error && <div className="alert alert-danger">{error}</div>}

            {/* Responsive Table */}
            <div className="table-responsive">
              <table
                ref={tableRef}
                className="table table-striped table-bordered display nowrap"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Name</th>
                    <th>Service</th>
                    <th>Plan </th>
                    <th>Payment Mode</th>
                    <th>Payment Status</th>
                    <th>Amount</th>
                    <th>Reciept</th>
                    <th>purpose</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions?.length > 0 ? (
                    transactions.map((transaction, index) => (
                      <tr key={transaction.id}>
                        <td>{index + 1}</td>
                        <td className="text-primary">{transaction.Username || "N/A"}</td>
                        <td>{transaction.ServiceName || "N/A"}</td>
                        <td>{transaction.PlanName || "N/A"}</td>
                        <td>{transaction.payment_mode || "N/A"}</td>
                        <td>{transaction.paymentstatus || "N/A"}</td>
                        <td>{transaction.paid_amount || "N/A"}</td>
                        <td>
                          {transaction.path ? (
                            <a  href={`https://apiaksharaconnect.aksharafinalytics.in/${transaction.path}`} target="_blank" rel="noopener noreferrer" title="Download" >
                              <Button variant="warning" size="sm" className="ms-2">
                                <FontAwesomeIcon icon={faDownload} />
                              </Button>
                            </a>
                          ) : (
                            "N/A"
                          )}
                        </td>
                        <td>{transaction.remarks || "N/A"}</td>
                        <td>{transaction.dop || "N/A"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No transactions available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionList;